












import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class PageSeparator extends Vue {
  @Prop({default: '', required: false}) private title!: string;
  @Prop({default: false, required: false}) private center!: boolean;
  @Prop({default: '', required: false}) private textClass!: string;
}
